import { http } from "../api";

const easyUnpack = ({ data }) => data;

export const BdDashboardApi = {
  rca_statistics: {
    f: function rca_statistics(params = {}) {
      const url = "/bd-dashboard/RCA-stats";
      return http.get(url, { params }).then(easyUnpack);
    },
  },
  report_statistics: {
    f: function report_statistics(params = {}) {
      const url = "/bd-dashboard/report-statistics";
      return http.get(url, { params }).then(easyUnpack);
    },
  },
  wind_diagnostics_statistics: {
    f: function wind_diagnostics_statistics(params = {}) {
      const url = "/bd-dashboard/wind-diagnostics-statistics";
      return http.get(url, { params }).then(easyUnpack);
    },
  },
  global_view: {
    f: function global_view() {
      const url = "/bd-dashboard/global-view";
      return http.get(url, { params: {} }).then(easyUnpack);
    },
  },
  blade_stats_years: {
    f: function blade_stats_years() {
      const url = "/bd-dashboard/blade-stats-years";
      return http.get(url, { params: {} }).then(easyUnpack);
    },
  },
  lassie_statistics: {
    f: function lassie_statistics() {
      const url = "/bd-dashboard/lassie-statistics";
      return http.get(url, { params: {} }).then(easyUnpack);
    },
  },
  access_lookup: {
    f: function access_lookup(params = {}) {
      const url = "/bd-dashboard/access-lookup";
      return http.get(url, { params }).then(easyUnpack);
    },
  },
  lightning_leads: {
    f: function lightning_leads(params = {}) {
      const url = "/bd-dashboard/lightning-leads";
      return http.get(url, { params }).then(easyUnpack);
    },
  },
  active_windfarms_map: {
    f: function active_windfarms_map(params = {}) {
      const url = "/bd-dashboard/active-windfarms-map";
      return http.get(url, { params }).then(easyUnpack);
    },
  },
  active_windfarm_detail: {
    f: function active_windfarm_detail(params = {}) {
      const url = "/bd-dashboard/active-windfarm-detail";
      return http.get(url, { params }).then(easyUnpack);
    },
  },
};
